import { render, staticRenderFns } from "./statistics-column.vue?vue&type=template&id=e6318b50&"
import script from "./statistics-column.vue?vue&type=script&lang=js&"
export * from "./statistics-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports